import React, { Component, Fragment } from "react";
import LoginTabset from "./loginTabset";

export class Login extends Component {
  render() {
    return (
      <Fragment>
        <div className="page-wrapper" id="okk">
          <div className="authentication-box">
            <div className="container">
              <div className="row">
                <div className="col-md-3 p-0 card-right"></div>
                <div className="col-md-7 p-0 card-right">
                  <div className="">
                    <div className="">
                      <LoginTabset />
                    </div>
                  </div>
                </div>
                <div className="col-md-3 p-0 card-right"></div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Login;
